import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import PrimarySearchAppBar from 'Components/PrimarySearchAppBar'

import { history } from '../_state/helpers'
import compose from 'recompose/compose'
import { connect } from 'react-redux'
import { organizationActions, userActions, metadataActions } from '../_state/actions'
import privateRoutes from 'routes/privateRoutes'

const styles = (theme) => ({
    main: {
        //padding: '20px',
        margin: '105px 0px 0px 0px',
        [theme.breakpoints.down('sm')]: {
            margin: '138px 0px 0px 0px',
        },
    },
    mainGryffindor: {
        //padding: '20px',
        margin: '64px 0px 0px 0px',
        [theme.breakpoints.down('sm')]: {
            margin: '138px 0px 0px 0px',
        },
    },
})

class PrivateLayout extends React.Component {
    constructor(props) {
        super(props)
        const organizationRoles = props.user?.info?.roles
            ? props.user.info.roles
                  .filter((x) => x.organizationId === props.organization.selectedOrganization)
                  .map((x) => x.role)
            : null
        if (!localStorage.getItem('authToken') || !organizationRoles) {
            history.push('/login')
            return
        }

        // The route gate is the real access boundary - menus only decide what is advertised, and a
        // url can always be typed. Three opt-in flags let a route be judged on something other
        // than "your role in the organization you happen to have selected".
        const route = privateRoutes.find((x) => x.path === props.path)

        const isSuperAdmin = props.user?.info?.isSuperAdmin === true
        const hasExplicitAllOrganizationAccess =
            isSuperAdmin || props.user?.info?.hasAllOrganizationsReporting === true

        const rolesAnywhere = props.user.info.roles.map((x) => x.role)
        const rolesToCheck = route.acceptRolesAnyOrganization ? rolesAnywhere : organizationRoles

        const allowed =
            route.acceptRoles.some((role) => rolesToCheck.includes(role)) &&
            (!route.requireSuperAdmin || isSuperAdmin) &&
            (!route.requireAllOrganizationAccess || hasExplicitAllOrganizationAccess)

        if (!allowed) {
            history.push('/dashboard/')
        }
        history.listen((location, action) => {
            // clear alert on location change
            // dispatch(alertActions.clear());
        })
    }

    componentDidMount() {
        const { user, organization } = this.props
        this.props.dispatch(userActions.getUserInfo(organization.selectedOrganization))
        this.props.dispatch(organizationActions.getMyOrganizations())
        this.props.dispatch(metadataActions.getMetadata())

        organization.selectedOrganization &&
            user.info.roles.forEach((element) => {
                if (element.organizationId == organization.selectedOrganization) {
                    switch (element.role) {
                        case 'Admin':
                            this.setState({ hasAdminRights: true, hasTeacherRights: false })
                            break
                        case 'Teacher':
                            this.setState({ hasAdminRights: false, hasTeacherRights: true })
                            break
                        default:
                            this.setState({ hasAdminRights: false, hasTeacherRights: false })
                    }
                }
            })
    }

    render() {
        const {
            component: Component,
            classes,
            location,
            history,
            dispatch,
            user,
            organization,
            computedMatch,
        } = this.props

        const organizationRoles = user?.info?.roles
            ? user.info.roles.filter((x) => x.organizationId === organization.selectedOrganization).map((x) => x.role)
            : null
        if (!organizationRoles) {
            return null
        }
        return (
            <div>
                {!window.location.pathname.includes('rnd/webgl') && (
                    <PrimarySearchAppBar showBreadcrumb={window.location.pathname !== '/'} dispatch={dispatch} />
                )}
                <div className={classes.main}>
                    <Component
                        location={location}
                        computedMatch={computedMatch}
                        history={history}
                        dispatch={dispatch}
                    />
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    const { organization, user } = state
    return {
        user,
        organization,
    }
}

PrivateLayout.propTypes = {
    classes: PropTypes.object.isRequired,
}

const enhance = compose(connect(mapStateToProps), withStyles(styles))

export default enhance(PrivateLayout)
